import { ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "./Reveal";

const POSTS = [
  {
    id: 1,
    tag: "Practice Management",
    title: "Your clinic's real numbers: where to start",
    excerpt: "Why most dentists underestimate the value of knowing their collections, chair time and leads — and how to fix it.",
    src: "https://images.unsplash.com/photo-1762625570087-6d98fca29531?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxkZW50YWwlMjBjbGluaWMlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODkyMTczMTB8MA&ixlib=rb-4.1.0&q=85",
    alt: "Modern dental clinic waiting area",
  },
  {
    id: 2,
    tag: "Technology",
    title: "AI in daily dentistry: practical, not hype",
    excerpt: "What an AI assistant can realistically do for a dental practice today — insights, drafts and reminders from your own data.",
    src: "https://images.unsplash.com/photo-1704455306251-b4634215d98f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxkZW50YWwlMjBjbGluaWMlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODkyMTczMTB8MA&ixlib=rb-4.1.0&q=85",
    alt: "Dental room desk and patient chair",
  },
  {
    id: 3,
    tag: "Practice Management",
    title: "One platform, fewer spreadsheets",
    excerpt: "From scattered notebooks and apps to a single connected system — what changes when your clinic data finally lives together.",
    src: "https://images.unsplash.com/photo-1629909613654-28e377c37b09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxkZW50aXN0JTIwZG9jdG9yfGVufDB8fHx8MTc4OTIxNzMwN3ww&ixlib=rb-4.1.0&q=85",
    alt: "Modern dental office interior",
  },
];

const Blog = () => (
  <section id="insights" data-testid="blog-section" className="py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">Latest from DENSA</p>
        <h2 className="mt-4 text-2xl font-bold tracking-tight text-brand-ink sm:text-3xl lg:text-4xl">
          Notes on running a <span className="text-brand">smarter practice.</span>
        </h2>
      </Reveal>

      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {POSTS.map((post, i) => (
          <Reveal key={post.id} delay={i * 0.08}>
            <article
              data-testid={`blog-card-${post.id}`}
              className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-brand/10"
            >
              <div className="overflow-hidden">
                <img
                  src={post.src}
                  alt={post.alt}
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand">{post.tag}</span>
                <h3 className="mt-2 text-lg font-semibold leading-snug text-brand-ink">{post.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{post.excerpt}</p>
                <button
                  type="button"
                  data-testid={`blog-read-more-${post.id}`}
                  onClick={() => toast.info("The DENSA journal is coming soon — stay tuned.")}
                  className="mt-5 inline-flex min-h-[44px] items-center gap-1.5 self-start text-sm font-semibold text-brand transition-colors hover:text-brand-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
                >
                  Read article
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" />
                </button>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Blog;
